'use client';

export { default } from './Tooltip';
export { default as tooltipClasses } from './tooltipClasses';
export * from './tooltipClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Tooltip/index.js
// module id = 513
// module chunks = 22